<div class="radio-container">
  <div class="radio-check">
    <rt-icon [name]="getIconName()" size="small"> </rt-icon>
  </div>

  <div class="label" [class.full-width-label]="fullWidthLabel">
    <!-- TODO replace this with `label: string` and `labelTemplate: TemplateRef` props -->
    <ng-content></ng-content>
  </div>
</div>

<input
  [value]="value"
  [checked]="checked"
  [disabled]="disabled"
  [readOnly]="readOnly"
  (change)="handleChange(!$any($event.target).checked ? value || true : false)"
  type="checkbox"
/>
